import { render, staticRenderFns } from "./main.unidadEmbalaje.vue?vue&type=template&id=02b658f5"
import script from "./main.unidadEmbalaje.vue?vue&type=script&lang=js"
export * from "./main.unidadEmbalaje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports